<template>
  <div id="videoWrap" style="width: 100%; height: 100%">
<!--    <video
      style="width: 100%; height: 100%"
      id="playerContainer"
      preload="auto"
      playsinline
      webkit-playsinline
    ></video>-->
    <div id="tcView"></div>

    <!-- 提示 -->
    <ComponentDialog1
      icon="fail"
      title="提示"
      tips="为了确保您还在观看视频 请点击以继续"
      :visible.sync="fiveMintDialog"
      iconPosition="center"
      :showCancelBtn="false"
      @confirm="continues"
      :showConfirmBtn="false"
      confirmText="继续学习"
    />
    <ComponentDialog1
      icon="fail"
      title="恭喜你，本章节学习完成"
      :tips="tips"
      :visible.sync="isDialogVisible"
      iconPosition="center"
      :showCancelBtn="false"
      :showConfirmCzBtn="true"
      :showConfirmNextBtn="showNextBtn"
      :confirmNextText="isGoToExam ? '去考试' : '下一节'"
      :showConfirmBtn="showConfirmBtn"
      :confirmText="btnText"
      @confirm="go"
      @confirmCz="btnTextCz"
      @confirmNext="confirmNext"
    />
  </div>
</template>
<script>
let jwt = require("jsonwebtoken");
let md5 = require("md5");
import ComponentDialog1 from "@/components/componentDialog1";
import { videoRecord } from "@/api/basic";
import {mapGetters} from "vuex";
// import { getSectionDetail } from "@/api/basic";
export default {
  components: {
    ComponentDialog1,
  },
  props: {
    videoData: {
      type: Object,
      default: null,
    },
    isFace: {
      type: Boolean,
      default: false,
    },
    sectionDatas: {
      type: Array,
      default: () => [],
    },
    lessonsUuid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      courseId: this.$route.query.course_id,
      lessonsId: "",
      appId: "1303139375",
      secretKey: "lFTQ6Vdtsa2D6i37uQfdJiqhIcfRwA7n",
      player: null,
      // isPaused: true,
      // startTime: 0,
      watch_duration: 15, //提交播放记录间隔时长
      course_info: {},
      section_info: {},
      isDialogVisible: false,
      fiveMintDialog: false,
      showNextBtn: true,
      showConfirmBtn: true,
      tips: "",
      btnText: "做作业",
      lastNode: 0,
      isTimeVideo: "",
      log_id: 0,
      isDrag:false,
      isGoToExam: false,  //是否去考试
      percentage: 0,  //学习总进度
    };
  },
  computed: {
    ...mapGetters(["videoPlayer"])
  },
  watch: {
    async videoData(val, oldVal) {
      // 切换前先提交当前播放时长
      // if (oldVal && this.player && !this.isPaused) {
      //   this.isPaused = true;
      //   clearInterval(this.isTimeVideo);
      //   await this.record();
      // }

      if (this.isTimeVideo) {
        clearInterval(this.isTimeVideo);
      }

      if (val) {
        this.getVideoUrl(val);
      }
    },
  },
  mounted() {
    if (this.videoData.section_info) {
      this.getVideoUrl(this.videoData);
    }
  },
  beforeDestroy() {
    this.destroyVideo();
  },
  methods: {
    // 判断是否可以去考试
    examHandle(){
      return new Promise(async (resolve, reject) => {
        let lessions = [];
        this.sectionDatas.forEach((item) => {
          if (item.node) {
            item.node.forEach((node) => {
              lessions.push(node.id);
            });
          }
        });

        let inx = lessions.indexOf(this.lessonsUuid);
        // 最后一章，最后一节
        if (inx == -1 || inx >= lessions.length - 1) {
          // 考查课程和进度学习完成
          if(this.videoData.section_info.exam_type == 2){
            // let percentage = await this.getPercentageData();
            if(this.percentage == 100){
              this.isGoToExam = true;
            }
          }
        }
        resolve();
      });
    },
    // 重新获取数据(进度)
    // getPercentageData(){
    //   return new Promise((resolve, reject) => {
    //     getSectionDetail({
    //       course_id: this.videoData.section_info.course_id,
    //       section_id: this.lessonsUuid,
    //     }).then((res) => {
    //       if (res.code == 200) {
    //         if (res.result) {
    //             resolve(res.result.section_info.percentage);
    //         } else {
    //           this.$message.warning(res.msg);
    //         }
    //       }
    //     });
    //   });
      
    // },
    /**
     * 获取视频数据
     */
    getVideoUrl(res) {
      const { course_info, section_info } = res;
      this.course_info = course_info;
      this.section_info = section_info;
      this.lessonsId = section_info.id;
      // this.createVideo(section_info.file_id);
      //是否可拖拽进度条
      if(course_info.is_forward != 0 || section_info.learn_status == 1){
        this.isDrag = true
      }
      else{
        this.isDrag = false
      }


      this.createVideoFn(section_info.video);
    },

    createVideoFn(url){
      // console.log(url);
      const _this = this;
      this.$nextTick(()=>{
        let p = document.getElementById('tcView');
        let v = document.getElementById('videoDomId');
        // let isDrag = this.isDrag

        if(!this.$base.isNull(v)){
          this.player.dispose();
          v.remove();
        }
        // if(!this.$base.isNull(this.videoPlayer)){
        //   this.videoPlayer.dispose();
        // }

        let x = document.createElement('video');
        x.setAttribute('id','videoDomId')
        x.setAttribute("preload",'auto')
        // x.setAttribute("poster",'')
        x.setAttribute("x5-video-player-type",'h5')
        x.setAttribute("x5-video-player-fullscreen",true)
        x.setAttribute("show-center-play-btn",false)
        x.setAttribute("x5-playsinline",'')
        x.setAttribute("x5-video-orientation",'portrait')
        x.setAttribute("playsinline",'')
        x.setAttribute("webkit-playsinline",'auto')
        x.setAttribute("width", p.clientWidth);
        x.setAttribute("height", p.clientHeight);
        p.appendChild(x)
        // this.player = TCPlayer("videoDomId", {
        //   fileID: fileId, // 视频ID
        //   appID: "1303139375",
        //   controlBar: {
        //     QualitySwitcherMenuButton: false,
        //     progressControl:isDrag,
        //     playbackRateMenuButton: false,
        //   },
        // });
        this.player = TCPlayer("videoDomId", {
        	controlBar: {
        		QualitySwitcherMenuButton: false,
        		progressControl:_this.isDrag,
        		playbackRateMenuButton: false,
        	},
        });
        this.player.src(url);
        // this.$store.commit('common/SET_PLAYER',this.player)
        // 设置上次播放时间
        this.player.one("canplay", () => {
          let rate = this.section_info.last_rate || 0;
          this.player.currentTime(rate);
          this.lastNode = this.section_info.last_rate;
        });
        // 绑定事件
        this.videoHandler();

      })


    },

    /**
     * 创建视频实例
     */
    createVideo(file_id) {
      // let psign = this.getPsign(file_id);

      if (!this.player) {
        this.player = TCPlayer("playerContainer", {
          fileID: file_id, // 视频ID
          appID: this.appId,
          // psign: psign,
          playbackRates: [1, 1.2, 1.5],
          controlBar: {
            QualitySwitcherMenuButton: false,
            progressControl: this.course_info.is_forward == 1, //是否可以快进
            playbackRateMenuButton: false, //this.course_info.course_type != 2, //认定课不显示倍率
          },
          flash: {
            swf: `//${this.appId}.vod2.myqcloud.com/vod-player/${this.appId}/${file_id}/tcplayer/player.swf`, //swf 文件地址（必须）
          },
          plugins: {
            ProgressMarker: true, // pick
          },
        });

        // 绑定事件
        this.videoHandler();
      } else {
        this.player.loadVideoByID({
          fileID: file_id,
          appID: this.appId,
          // psign: psign,
        });
      }

      // 设置上次播放时长
      this.player.one("canplay", () => {
        let rate = this.section_info.last_rate || 0;
        this.player.currentTime(rate);
        this.lastNode = this.section_info.last_rate;
      });
    },
    /**
     * 播放器签名(防盗链开启时需要)
     */
    getPsign(fileId) {
      let current = parseInt(new Date().getTime() / 1000);
      let expired = current + 86400 * 90; // 签名有效期：90天
      let urlTimeExpire = expired.toString(16);

      let payload = {
        appId: this.appId,
        fileId: fileId,
        currentTimeStamp: current,
        expireTimeStamp: expired,
        urlAccessInfo: {
          t: urlTimeExpire,
        },
      };
      let psign = jwt.sign(payload, this.secretKey);
      return psign;
    },
    timeVideo() {
      this.isTimeVideo = setInterval(() => {
        this.record();
      }, this.watch_duration * 1000);
    },
    /**
     * 视频事件
     */
    videoHandler() {
      this.player.on("play", () => {
        // this.isPaused = false;
        // this.startTime = new Date().getTime();
        this.timeVideo();
      });

      this.player.on("pause", () => {
        clearInterval(this.isTimeVideo);

        // if (!this.isPaused) {
        //   this.isPaused = true;
        //   this.record();
        //   clearInterval(this.isTimeVideo);
        // }
      });

      this.player.on("ended", async () => {
        const { course_type } = this.section_info;
        await this.record();
        // await this.examHandle();
        this.isDialogVisible = true;
        this.showConfirmBtn = course_type != 3;
        this.btnText = course_type == 2 ? "做作业" : "章节练习";
        this.lastNode = parseInt(this.player.currentTime());
      });

      this.player.on("timeupdate", () => {
        let face_recognition = this.course_info.face_recognition * 60;
        let currentTime = parseInt(this.player.currentTime());

        // console.log(currentTime, this.lastNode);
        if (
          face_recognition > 0 &&
          currentTime > this.lastNode &&
          currentTime % face_recognition == 0
        ) {
          // this.record();
          // this.isPaused = true;
          this.player.pause();
          this.$emit("isShowFace");
        }
      });
    },
    offHandler() {
      this.player.off("play");
      this.player.off("pause");
      this.player.off("ended");
    },
    resetVideo() {
      let rate = this.section_info.last_rate || 0;
      this.player.currentTime(rate);
    },
    videoPlay() {
      this.lastNode = parseInt(this.player.currentTime());
      this.player.play();
    },
    /**
     * 提交播放记录
     */
    async record() {
      let endTime = new Date().getTime();
      //let watch_duration = parseInt((endTime - this.startTime) / 1000);
      // this.startTime = endTime;
      let current_node = Math.ceil(this.player.currentTime());
      let time = endTime / 1000;
      let is_complete =
        current_node == this.section_info.video_duration ? 1 : 0;
      let str = `course_id=${this.courseId}&section_id=${this.lessonsId}&watch_duration=${this.watch_duration}&current_node=${current_node}&time=${time}`;
      let sign = md5(str);

      const params = {
        course_id: this.courseId,
        section_id: this.lessonsId,
        current_node: current_node,
        watch_duration: this.watch_duration,
        sign: sign,
        time: time,
        is_complete: is_complete,
        log_id: this.log_id,
      };

      const res = await videoRecord(params);
      if (res) {
        this.log_id = res.result.log_id;
        this.percentage = res.result.percentage;
        await this.examHandle();
      }
    },
    /**
     * 销毁视频
     */
    async destroyVideo() {
      if (this.player) {
        // if (!this.isPaused) {
        //   this.isPaused = true;
        //   await this.record();
        //   clearInterval(this.isTimeVideo);
        // }
        clearInterval(this.isTimeVideo);
        this.offHandler();
        this.player.dispose();
        this.player = null;
      }
    },
    // 提示
    continues() {
      this.fiveMintDialog = false;
    },
    // 再次播放
    btnTextCz() {
      this.isDialogVisible = false;
      this.player.currentTime(0);
      this.player.play();
    },
    // 下一节
    confirmNext() {
      if(this.isGoToExam){
        this.$router.push({
          name: "courseAdult",
          query: {
            
          },
        });
        // this.$router.push({
        //   name: "onlineTest",
        //   query: {
        //     // typeTest: this.type,
        //     // test_id: this.test_id,
        //     course_id: this.videoData.section_info.course_id,
        //     // exam_id: this.exam_id
        //     page: 'courseAdult',  //这里逻辑跟课程学习页面一样
        //   },
        // });
      }else{
        this.isDialogVisible = false;
        this.$emit("lessonChangeNext");
      }
    },
    // 做作业
    go() {
      let name =
        this.section_info.course_type == 2 ? "homeWork" : "startPractice";
      this.$router.push({
        name: name,
        query: {
          course_id: this.courseId,
          section_id: this.lessonsId,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.vjs-menu li.vjs-selected,
.vjs-menu li.vjs-selected:focus,
.vjs-menu li.vjs-selected:hover {
  background-color: green;
  color: #fff;
}
#tcView{
  width: 100%;
  height: 100%;
}
</style>
